import * as api from "../Api";

export const getStockReceived = () => async (dispatch) => {
  try {
    const { data } = await api.getStockReceived();
    dispatch({ type: "GET_ALL_STOCK_RECEIVED", payload: data });
  } catch (error) {}
};
